import { toast } from '@/lib/hooks/use-toast';

/** Lo que devuelve aprobar cuando la empresa tiene «Publicar al aprobar» (25-oct). */
export interface PublicacionEnTienda {
  tienda: string;
  aplicados: number;
  error: string | null;
}

/**
 * Avisa en pantalla lo que pasó en la tienda conectada al aprobar: el precio ya
 * quedó aprobado en Prixia; esto dice si además llegó a la tienda online.
 * Sin tienda con «Publicar al aprobar», no dice nada.
 */
export function avisarPublicacion(resultado: unknown): void {
  const publicaciones = (resultado as { tienda?: PublicacionEnTienda[] } | null)?.tienda;
  if (!Array.isArray(publicaciones)) return;
  for (const p of publicaciones) {
    if (p.error) {
      toast({
        title: `No se pudo publicar en ${p.tienda}`,
        description: `El precio quedó aprobado en Prixia. La tienda dijo: ${p.error}`,
        variant: 'destructive',
      });
    } else if (p.aplicados > 0) {
      toast({
        title: `Publicado en ${p.tienda}`,
        description:
          p.aplicados === 1
            ? 'El precio nuevo ya está en tu tienda online.'
            : `Los ${p.aplicados} precios nuevos ya están en tu tienda online.`,
        variant: 'success',
      });
    }
  }
}
